import {
  isDniFeatureEnabled,
  isDniRegisteredFeatureEnabled
} from '@/config/featureFlags';
import type { AuthorizedPerson } from '@/modules/cart/domain/Cart';
import environment from '@/modules/cart/environments/environment';
import type { HttpCartDto } from '@/modules/cart/infrastructure/dto/HttpCartRepositoryDto';
import httpClient from '@/modules/cart/services/api/client';

const { CART_URL } = environment;

const ON_BEHALF_URL = `${CART_URL}/shipping-methods`;

export async function setOnBehalf(
  deliveryGroupId: string,
  authorizedPerson: AuthorizedPerson,
  cartId: string,
  isRegisteredUser: boolean = false
): Promise<{ data: HttpCartDto }> {
  const isDniEnabled = isRegisteredUser
    ? isDniRegisteredFeatureEnabled()
    : isDniFeatureEnabled();
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  const payload: any = {};

  if (
    isDniEnabled &&
    authorizedPerson?.documentType &&
    authorizedPerson?.documentID
  ) {
    payload.collectOnBehalfName = authorizedPerson?.fullname;
    payload.collectOnBehalfDocumentType = authorizedPerson?.documentType;
    payload.collectOnBehalfDocumentID = authorizedPerson?.documentID;
    payload.collectOnBehalfRut = authorizedPerson?.documentID;
  } else if (authorizedPerson?.rut || authorizedPerson?.documentID) {
    // Legacy format (backward compatibility)
    payload.collectOnBehalfName = authorizedPerson?.fullname;
    payload.collectOnBehalfRut =
      authorizedPerson?.rut || authorizedPerson?.documentID;
  } else {
    // Delete authorized person (empty payload)
  }

  return await httpClient.patch(
    `${ON_BEHALF_URL}/${deliveryGroupId}/on-behalf`,
    payload,
    {
      headers: {
        'x-cart-id': cartId
      }
    }
  );
}
